/*
  The Provider Profile design has different breakpoints
  than the `@kyruus/ui-theme` breakpoints.
  Designs and breakpoints: https://kyruus.jira.com/browse/KENG-31924
*/
export const BREAKPOINTS = {
  small: 632,
  medium: 840,
  large: 992
};

/*
  These values' production definitions are not yet available.
  They are centralized here for now.
  Followup: https://kyruus.jira.com/browse/KENG-32224
*/
export const PROFILE_SECTION_IDS = {
  PROFILE_TOP: 'profile-top',
  HIGHLIGHTS: 'profile-highlights',
  ABOUT: 'profile-about',
  APPOINTMENTS: 'profile-appointments',
  VIDEOS: 'profile-videos',
  LOCATIONS: 'profile-locations',
  CLINICAL_INTERESTS: 'profile-clinical-interests',
  EXPERTISE: 'profile-expertise',
  INSURANCE_ACCEPTED: 'profile-insurance-accepted',
  REVIEWS: 'profile-reviews',
  // NETWORK_AFFILIATIONS: 'profile-network-affiliations',
  // INFORMATION_CARDS: 'profile-information-cards',
  CARE_TEAM: 'profile-care-team',
  SIMILAR_PROVIDERS: 'profile-similar-providers',
  SCHEDULE_APPOINTMENTS: 'profile-schedule-appointments'
};

export const DEFAULT_PROFILE_SECTIONS_ORDER = [
  // PROFILE_TOP isn't a customizable section so is excluded here
  PROFILE_SECTION_IDS.SCHEDULE_APPOINTMENTS,
  PROFILE_SECTION_IDS.HIGHLIGHTS,
  PROFILE_SECTION_IDS.ABOUT,
  PROFILE_SECTION_IDS.APPOINTMENTS,
  PROFILE_SECTION_IDS.VIDEOS,
  PROFILE_SECTION_IDS.LOCATIONS,
  PROFILE_SECTION_IDS.CLINICAL_INTERESTS,
  PROFILE_SECTION_IDS.EXPERTISE,
  PROFILE_SECTION_IDS.INSURANCE_ACCEPTED,
  PROFILE_SECTION_IDS.REVIEWS,
  PROFILE_SECTION_IDS.CARE_TEAM,
  PROFILE_SECTION_IDS.SIMILAR_PROVIDERS
];

export const RATINGS_AND_REVIEWS = {
  SUMMARY_STAR_SIZE_DESKTOP: 17,
  SUBCATEGORY_STAR_SIZE: 14,
  STAR_INNER_MARGIN: 6,
  /* additional width to calibrate the rating value with the filled stars */
  SUMMARY_STARS_ACCURACY_CORRECTION_WIDTH: 5,
  /* additional width to calibrate the rating value with the filled stars */
  SUBCATEGORY_STARS_ACCURACY_CORRECTION_WIDTH: 0
};

export const STATIC_MAP = {
  small_image_size: '350x200',
  medium_image_size: '600x226',
  large_image_size: '845x226',
  small_map_height: '200px',
  medium_map_height: '226px',
  large_map_height: '226px'
};

// css values
export const PROFILE_BOTTOM_HEIGHT = '92px';
export const PROFILE_IMAGE_MAX_HEIGHT = '225px';
export const PROFILE_IMAGE_MAX_HEIGHT_MOBILE = '160px';
export const PROFILE_IMAGE_MAX_WIDTH = '300px';
// The sticky nav height is always between 50-60px
export const STICKY_NAV_SCROLL_MARGIN = '80px';

export const VIRTUAL_VISIT_TYPES = {
  VIDEO: 'video'
};

export const EntityIds = {
  ACCESSIBLE: 'ACC0000000002',
  VALET_PARKING: 'ACC0000000003',
  TRANSLATION: 'ACC0000000004',
  AMERICAN_SIGN_LANGUAGE: 'ACC0000000005',
  PARKING: 'ACC0000000006'
};

export const TRACKING_EVENTS = {
  INSURANCE_DISCLAIMER_LINK_CLICKED:
    'user_action.insurance_disclaimer_hyperlink_clicked',
  BOUNDARY_ERROR: 'v9_provider_profile.boundary_error'
};

// these fields are configured in config.provider_v9.summary_data but are not displayed in the About section (they are displayed above in their own sections)
export const ABOUT_SECTION_EXCLUDE_SUMMARY_DATA_FIELDS = [
  'specialties',
  'network_affiliations',
  'telehealth',
  'age_groups_seen',
  'languages',
  'gender',
  'insurance_accepted',
  'video_url'
];

export const SEARCH_INPUT_REVIEW_COUNT = 6;

export const VIMEO_VIDEO_BASE_URL = 'https://player.vimeo.com/video';

export const USER_ACTION = 'user_action';

export const PROFILE_NAV = `${USER_ACTION}.provider_detail.nav`;

export const MAX_AVAILABILITIES_TO_DISPLAY = 6;
export const EXTENDED_AVAILABILITIES_DISPLAY_LIMIT = 12;

export const PROVIDER_NAME_HEADER_ID = 'provider-name-header';

export const PROFILE_V9_MAX_WIDTH = '1440px';

export const APPT_OPTIONS_KEYS = {
  RELATIONSHIP: 'relationship',
  PURPOSE: 'purpose'
};
